import { Eye } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/* COG-009 §4.6 — visualizacao do atendimento ("Ver como padrinho" do painel do ChildFund, dentro de um iframe): faixa
   fixa no topo de todas as telas. O servidor recusa qualquer gravacao (SPONSOR_READ_ONLY_VIEW); a faixa so avisa. */
export function StaffViewBanner() {
    const { t } = useTranslation()
    return (
        <div role="status" className="sticky top-0 z-30 flex items-center justify-center gap-2 bg-ink px-4 py-2 text-center text-[0.78rem] font-semibold text-white">
            <Eye className="size-4 shrink-0" aria-hidden="true" />
            {t('sponsorShell.staffView')}
        </div>
    )
}
